export function formatTVA(numero: string | null | undefined): string {
  if (!numero) return '';
  numero = numero.trim();
  if (numero.toUpperCase().startsWith('BE')) {
    return numero;
  }
  return 'BE' + numero;
}
